<div class="d-flex align-items-center dropdown user-info" bsDropdown placement="bottom left">
  <div class="d-flex align-items-center clickable dropdown-toggle" dropdownToggle>
    <gcc-user-ava [user]="user" size="sm"></gcc-user-ava>
  </div>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right note" role="menu">
    <li class="d-flex align-items-center px-4 py-1">
      <gcc-user-ava [user]="user" size="lg"></gcc-user-ava>
      <div class="px-3">
        <div class="note semibold">{{ user.fullName }}</div>
        <div class="caption text-lightgray">{{ user.jobTitle }}</div>
      </div>
    </li>
    <li role="menuitem">
      <button type="button" class="btn btn-link d-flex align-items-center px-4 py-2 dropdown-item">
        <i class="text-gray icon icon-flag icon-16 mr-3"></i>
        <span class="flex-grow-1">{{ 'header.user_info.default_country' | translate }}</span>
        <span>{{ accountService.countryCode$ | async }}</span>
      </button>
    </li>
    <li role="menuitem">
      <button type="button" class="btn btn-link d-flex align-items-center px-4 py-2 dropdown-item">
        <i class="text-gray icon icon-country icon-16 mr-3"></i>
        <span class="flex-grow-1"> {{ 'header.user_info.language' | translate }}</span>
        <span>{{ 'header.user_info.eng' | translate }}</span>
      </button>
    </li>
    <li role="menuitem">
      <a (click)="surveyHandler()" class="d-flex align-items-center px-4 py-2 dropdown-item">
        <i class="text-gray icon icon-comment-no-dots icon-16 mr-3"></i>
        <span>Send feedback form</span>
      </a>
    </li>
    <li role="menuitem">
      <a [href]="mailtoLink" class="d-flex align-items-center px-4 py-2 dropdown-item">
        <i class="text-gray icon icon-letter icon-16 mr-3"></i>
        <span>Support</span>
      </a>
    </li>
    <li class="divider dropdown-divider mx-4"></li>
    <li role="menuitem">
      <a
        class="d-flex align-items-center px-4 py-2 dropdown-item"
        target="_blank"
        href="https://deloittenet.deloitte.com/system/pages/Use.aspx"
      >
        <i class="text-gray icon icon-document icon-16 mr-3"></i>
        <span> {{ 'header.user_info.terms_of_use' | translate }}</span>
      </a>
    </li>
    <li role="menuitem">
      <a
        class="d-flex align-items-center px-4 py-2 dropdown-item"
        target="_blank"
        href="https://deloittenet.deloitte.com/system/Pages/Personnel_Privacy_Notice.aspx"
      >
        <i class="text-gray icon icon-shield icon-16 mr-3"></i>
        <span> {{ 'header.user_info.privacy_policy' | translate }}</span>
      </a>
    </li>
    <li class="divider dropdown-divider mx-4"></li>
    <li role="menuitem">
      <a
        class="d-flex align-items-center px-4 py-2 dropdown-item"
        target="_blank"
        href="https://cookienotice.deloitte.com"
      >
        <i class="text-gray icon icon-cookies icon-16 mr-3"></i>
        <span>Cookies</span>
      </a>
    </li>
    <li role="menuitem" (click)="onCookieSettings($event)">
      <a class="d-flex align-items-center px-4 py-2 dropdown-item" href="javascript:void(0);">
        <i class="text-gray icon icon-settings icon-16 mr-3"></i>
        <span>Cookie Settings</span>
      </a>
    </li>
    <li class="divider dropdown-divider mx-4"></li>
    <li role="menuitem">
      <button type="button" class="btn btn-link d-flex align-items-center px-4 py-2 dropdown-item" (click)="onLogout()">
        <i class="text-gray icon icon-exit icon-16 mr-3"></i>
        <span> {{ 'header.user_info.sign_out' | translate }}</span>
      </button>
    </li>
  </ul>
</div>
